import { render, staticRenderFns } from "./RegisterPracticeReminder.vue?vue&type=template&id=6bc5adca"
import script from "./RegisterPracticeReminder.vue?vue&type=script&lang=js"
export * from "./RegisterPracticeReminder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports